export interface TickerEvent {
  time: string
  domain: string
  detail: string
  state: 'ok' | 'warn' | 'down' | 'sent'
}

/** The kind of traffic the scheduler produces on an ordinary morning. */
export const tickerEvents: TickerEvent[] = [
  { time: '08:00:01', domain: 'acme.com', detail: 'cert valid · 58d', state: 'ok' },
  { time: '08:00:02', domain: 'shop.acme.com', detail: 'cert valid · 9d', state: 'warn' },
  { time: '08:00:03', domain: 'shop.acme.com', detail: 'warning emailed · 2 recipients', state: 'sent' },
  { time: '08:00:04', domain: 'api.acme.com', detail: 'cert valid · 76d', state: 'ok' },
  { time: '08:00:05', domain: 'blog.acme.com', detail: 'cert renewed · Google Trust WE1', state: 'ok' },
  { time: '08:00:06', domain: 'legacy.acme.io', detail: 'handshake failed', state: 'down' },
  { time: '08:01:00', domain: 'api.acme.com', detail: 'HTTP 500 · failure 3 of 3', state: 'down' },
  { time: '08:01:01', domain: 'api.acme.com', detail: 'downtime alert emailed', state: 'sent' },
  { time: '08:01:12', domain: 'status.acme.com', detail: 'HTTP 200 · 318ms', state: 'ok' },
  { time: '08:02:00', domain: 'acme.com', detail: 'HTTP 200 · 182ms', state: 'ok' },
]
